import { __decorate } from "tslib";
import { Injectable, isDevMode } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";
import { map } from "rxjs/operators";
import { LocalStorageService } from "../storage/local-storage.service";
import { OAuthService } from "angular-oauth2-oidc";
import { JwksValidationHandler } from "angular-oauth2-oidc-jwks";
import { AppConfig } from "../../../app.config";
import { SessionStorageService } from "../storage/session-storage.service";
import { SessionStorageEnum } from "../storage/session-storage-constants";
export let AuthService = class AuthService {
    http;
    localStorage;
    sessionStorageService;
    oauthService;
    appConfig;
    $isNotAuthenticated;
    authenticationTokenSubject = new BehaviorSubject("");
    $authenticationToken = this.authenticationTokenSubject.asObservable();
    isAuthenticatedSubject = new BehaviorSubject(false);
    $isAuthenticated = this.isAuthenticatedSubject.asObservable();
    constructor(http, localStorage, sessionStorageService, oauthService, appConfig) {
        this.http = http;
        this.localStorage = localStorage;
        this.sessionStorageService = sessionStorageService;
        this.oauthService = oauthService;
        this.appConfig = appConfig;
        this.setupListeners();
        this.listenForSecurityTokenServiceEvents();
    }
    configureAuth() {
        const authConfig = AppConfig.settings.ids;
        authConfig.useSilentRefresh = true;
        this.oauthService.configure(authConfig);
        this.oauthService.loadDiscoveryDocument();
    }
    authenticate() {
        const authConfig = AppConfig.settings.ids;
        authConfig.useSilentRefresh = true;
        this.oauthService.configure(authConfig);
        this.oauthService.loadDiscoveryDocument();
        if (this.checkIfLoggedIn()) {
            this.oauthService.setupAutomaticSilentRefresh();
            return Promise.resolve(true);
        }
        this.oauthService.setupAutomaticSilentRefresh();
        this.oauthService.tokenValidationHandler = new JwksValidationHandler();
        const call = this.oauthService.loadDiscoveryDocumentAndLogin();
        call.then(() => {
            this.handleLoginAttempt();
        });
        return call;
    }
    unAuthenticate() {
        this.oauthService.revokeTokenAndLogout();
        this.oauthService.logOut();
        this.publishTokenValidityChange(false);
    }
    logOutRedirect() {
        //this.oauthService.logOut();
        const url = `${AppConfig.settings.ids.issuer}/Account/LogoutClient?returnUrl=${AppConfig.settings.ids.redirectUri}`;
        window.open(url, "_self");
        //this.publishTokenValidityChange(false);
    }
    unAuthenticateFrontChannel() {
        const authConfig = AppConfig.settings.ids;
        authConfig.useSilentRefresh = true;
        this.oauthService.configure(authConfig);
        const call = this.oauthService.loadDiscoveryDocument();
        call.then(() => {
            this.oauthService.revokeTokenAndLogout();
            this.publishTokenValidityChange(false);
        });
    }
    checkIfLoggedIn() {
        if (this.oauthService.hasValidAccessToken()) {
            this.handleTokenValid();
            return true;
        }
        return false;
    }
    localLogout() {
        this.oauthService.logOut(true);
        this.publishTokenValidityChange(false);
    }
    setupListeners() {
        this.$isNotAuthenticated = this.$isAuthenticated.pipe(map((isAuthenticated) => !isAuthenticated));
    }
    handleLoginAttempt() {
        const isTokenValid = this.oauthService.hasValidIdToken();
        if (isTokenValid) {
            this.handleTokenValid();
        }
        else {
            throw new Error("Unable to authenticate");
        }
    }
    publishTokenValidityChange(value) {
        this.isAuthenticatedSubject.next(value);
    }
    publishToken(accessToken) {
        this.authenticationTokenSubject.next(accessToken);
    }
    handleTokenValid() {
        this.sessionStorageService.set(SessionStorageEnum.IsUserAuthenticated, "true");
        this.localStorage.set(SessionStorageEnum.IsUserAuthenticated, "true");
        this.publishToken(this.oauthService.getAccessToken());
        this.publishTokenValidityChange(true);
    }
    listenForSecurityTokenServiceEvents() {
        this.oauthService.events.subscribe((event) => {
            if (!isDevMode()) {
                console.log(event);
            }
        });
    }
    static ctorParameters = () => [
        { type: HttpClient },
        { type: LocalStorageService },
        { type: SessionStorageService },
        { type: OAuthService },
        { type: AppConfig }
    ];
};
AuthService = __decorate([
    Injectable()
], AuthService);
